import { render, staticRenderFns } from "./sand_8.vue?vue&type=template&id=d378658e&scoped=true&"
import script from "./sand_8.vue?vue&type=script&lang=js&"
export * from "./sand_8.vue?vue&type=script&lang=js&"
import style0 from "./sand_8.vue?vue&type=style&index=0&id=d378658e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d378658e",
  null
  
)

export default component.exports